import styled from 'styled-components';

export const CandidateDetailsWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .refuse {
    .ant-btn,
    .ant-btn:hover,
    .ant-btn:focus {
      border-color: ${({ theme }) => theme.colors.tone.red};
      color: ${({ theme }) => theme.colors.tone.red};
    }
  }
`;
